( function () {
	'use strict';

	function adjustTextarea ( $timeout ) {
		return {
			'restrict' : 'A',
			'link'     : function ( scope, element ) {
				element.on( 'click', function () {
					$timeout( function () {
						scope.$broadcast( 'elastic:adjust' );
					}, 100 );
				} );
			}
		};
	}

	angular
		.module( 'app.components' )
		.directive( 'adjustTextarea', adjustTextarea );

	adjustTextarea.$inject = [ '$timeout' ];
} )( );
